
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7c47"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7c47"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kUkf0", function(module, exports) {
module.exports = $parcel$import("bVcxT").then(()=>parcelRequire('f2jse'));

});

parcelRegister("kRT5c", function(module, exports) {
module.exports = $parcel$import("14FgH").then(()=>parcelRequire('kXVEY'));

});

parcelRegister("1C2eD", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("7jkLd"))($parcel$resolve("d6amJ")),
    $parcel$import("g4LWw")
]).then(()=>parcelRequire('eE1OS'));

});
parcelRegister("7jkLd", function(module, exports) {
"use strict";

var $boLNp = parcelRequire("boLNp");
module.exports = $boLNp(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("boLNp", function(module, exports) {
"use strict";
var $84c702df89f2997b$var$cachedBundles = {};
var $84c702df89f2997b$var$cachedPreloads = {};
var $84c702df89f2997b$var$cachedPrefetches = {};
function $84c702df89f2997b$var$getCache(type) {
    switch(type){
        case 'preload':
            return $84c702df89f2997b$var$cachedPreloads;
        case 'prefetch':
            return $84c702df89f2997b$var$cachedPrefetches;
        default:
            return $84c702df89f2997b$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $84c702df89f2997b$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("jho76", function(module, exports) {
module.exports = $parcel$import("aJYfA").then(()=>parcelRequire('8avko'));

});

parcelRegister("6h2ZC", function(module, exports) {
module.exports = $parcel$import("8umzv").then(()=>parcelRequire('6MVYT'));

});

parcelRegister("e9lkY", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("7jkLd"))($parcel$resolve("j6hDl")),
    $parcel$import("7IxBd")
]).then(()=>parcelRequire('7wQ2f'));

});

parcelRegister("4aMyn", function(module, exports) {
module.exports = $parcel$import("7HkY3").then(()=>parcelRequire('jqV1o'));

});

parcelRegister("wmyCC", function(module, exports) {
module.exports = $parcel$import("4aZc2").then(()=>parcelRequire('043de'));

});

parcelRegister("aY5zW", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("7jkLd"))($parcel$resolve("fUrYi")),
    $parcel$import("1JBF7")
]).then(()=>parcelRequire('99d0j'));

});

parcelRegister("cZVn5", function(module, exports) {
module.exports = $parcel$import("1rEcN").then(()=>parcelRequire('iij5j'));

});

parcelRegister("cTvfh", function(module, exports) {
module.exports = $parcel$import("30cuK").then(()=>parcelRequire('i7Aty'));

});

parcelRegister("9a4rI", function(module, exports) {
module.exports = $parcel$import("5igcT").then(()=>parcelRequire('j3gV0'));

});

parcelRegister("3DiM9", function(module, exports) {

module.exports = Promise.all([
    $parcel$import("4BMCH"),
    (parcelRequire("7jkLd"))($parcel$resolve("iBKRP")),
    $parcel$import("engdc")
]).then(()=>parcelRequire('4T2DT'));

});

parcelRegister("gWmnw", function(module, exports) {
module.exports = $parcel$import("inxyF").then(()=>parcelRequire('i7aMr'));

});

parcelRegister("aAMLD", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("7jkLd"))($parcel$resolve("cws5h")),
    $parcel$import("gOKIm")
]).then(()=>parcelRequire('hMyM7'));

});

parcelRegister("fqTok", function(module, exports) {
module.exports = $parcel$import("kyRNs").then(()=>parcelRequire('8cAla'));

});

parcelRegister("2whGw", function(module, exports) {
module.exports = $parcel$import("cipen").then(()=>parcelRequire('l0e0U'));

});

parcelRegister("ib06j", function(module, exports) {
module.exports = $parcel$import("7qf8x").then(()=>parcelRequire('24jNb'));

});

parcelRegister("byeGr", function(module, exports) {
module.exports = $parcel$import("2Vn8K").then(()=>parcelRequire('2nvqf'));

});

parcelRegister("gQuGa", function(module, exports) {
module.exports = $parcel$import("ic8EN").then(()=>parcelRequire('c1HwP'));

});

parcelRegister("agtdj", function(module, exports) {
module.exports = $parcel$import("jkBNP").then(()=>parcelRequire('4aO5d'));

});

parcelRegister("3jY46", function(module, exports) {
module.exports = $parcel$import("4dkd1").then(()=>parcelRequire('cO27o'));

});

parcelRegister("ggz7T", function(module, exports) {
module.exports = $parcel$import("iK7i3").then(()=>parcelRequire('bbAhp'));

});

parcelRegister("lsfvb", function(module, exports) {
module.exports = $parcel$import("1vmBn").then(()=>parcelRequire('7NJzN'));

});

parcelRegister("VWzl8", function(module, exports) {
module.exports = $parcel$import("4TnBi").then(()=>parcelRequire('95nHd'));

});

parcelRegister("iAQmS", function(module, exports) {
module.exports = $parcel$import("6bSle").then(()=>parcelRequire('d9qxl'));

});

parcelRegister("73LSn", function(module, exports) {
module.exports = $parcel$import("ehJ5h").then(()=>parcelRequire('bLP21'));

});

parcelRegister("8pwOZ", function(module, exports) {
module.exports = $parcel$import("6SbjX").then(()=>parcelRequire('eSNAw'));

});

parcelRegister("k9xZt", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("4BMCH"),
    $parcel$import("cl257")
]).then(()=>parcelRequire('gWqmw'));

});

parcelRegister("hPGrL", function(module, exports) {
module.exports = $parcel$import("evt8e").then(()=>parcelRequire('dWWfH'));

});

var $b85fad806e9a54c0$exports = {};
$parcel$extendImportMap({
    "bVcxT": "fancybox-gallery-id-generator.11da9be0.js",
    "14FgH": "entry-content-fancybox-image.f9d93495.js",
    "g4LWw": "fancybox.eea376c7.js",
    "d6amJ": "fancybox.c8d045d5.css",
    "aJYfA": "modal.6f874ff6.js",
    "8umzv": "file-field.0fd99f16.js",
    "7IxBd": "date-field.679f9c2a.js",
    "j6hDl": "date-field.775c328b.css",
    "7HkY3": "text-field--password.39557ef4.js",
    "4aZc2": "calendar-section.db1321aa.js",
    "1JBF7": "slim-select.81f075fe.js",
    "fUrYi": "slim-select.363ecc8c.css",
    "1rEcN": "alert-item.8980a4ef.js",
    "30cuK": "notification-item.b103374e.js",
    "5igcT": "faq-item.568a8df3.js",
    "engdc": "swiper.43774b66.js",
    "iBKRP": "swiper.49a434eb.css",
    "4BMCH": "swiper.9b1612d6.js",
    "inxyF": "checkbox-select-field.362fc9df.js",
    "gOKIm": "overlayscrollbars.9fffd68c.js",
    "cws5h": "overlayscrollbars.ad124755.css",
    "kyRNs": "base-form.0e25fc3e.js",
    "cipen": "scroll-up.d746684f.js",
    "7qf8x": "theme-config.fc770778.js",
    "2Vn8K": "tabs.dbfb18f2.js",
    "ic8EN": "svg.68f3be1a.js",
    "jkBNP": "menu-item.d07084b8.js",
    "4dkd1": "main-header-search.b956c9bb.js",
    "iK7i3": "entry-content-iframe.379a5b00.js",
    "1vmBn": "entry-content-width-height.5227aa95.js",
    "4TnBi": "menu-item.763e5d5c.js",
    "6bSle": "aside.03170718.js",
    "ehJ5h": "honey.abefc15e.js",
    "6SbjX": "text-and-media-slider-group.5a2463df.js",
    "cl257": "review-group--slider.bca38e37.js",
    "evt8e": "video-section.0ffe2259.js"
});


var $fdddc8610c676f7c$exports = {};
!function(e, t) {
    $fdddc8610c676f7c$exports = t();
}($fdddc8610c676f7c$exports, function() {
    "use strict";
    const e = "undefined" != typeof window, t = e && !("onscroll" in window) || "undefined" != typeof navigator && /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent), a = e && window.devicePixelRatio > 1, n = {
        elements_selector: ".lazy",
        container: t || e ? document : null,
        threshold: 300,
        thresholds: null,
        data_src: "src",
        data_srcset: "srcset",
        data_sizes: "sizes",
        data_bg: "bg",
        data_bg_hidpi: "bg-hidpi",
        data_bg_multi: "bg-multi",
        data_bg_multi_hidpi: "bg-multi-hidpi",
        data_bg_set: "bg-set",
        data_poster: "poster",
        class_applied: "applied",
        class_loading: "loading",
        class_loaded: "loaded",
        class_error: "error",
        class_entered: "entered",
        class_exited: "exited",
        unobserve_completed: !0,
        unobserve_entered: !1,
        cancel_on_exit: !0,
        callback_enter: null,
        callback_exit: null,
        callback_applied: null,
        callback_loading: null,
        callback_loaded: null,
        callback_error: null,
        callback_finish: null,
        callback_cancel: null,
        use_native: !1,
        restore_on_error: !1
    }, s = (e)=>Object.assign({}, n, e), l = function(e, t) {
        let a;
        const n = "LazyLoad::Initialized", s = new e(t);
        try {
            a = new CustomEvent(n, {
                detail: {
                    instance: s
                }
            });
        } catch (e) {
            a = document.createEvent("CustomEvent"), a.initCustomEvent(n, !1, !1, {
                instance: s
            });
        }
        window.dispatchEvent(a);
    }, o = "src", r = "srcset", i = "sizes", d = "poster", c = "llOriginalAttrs", _ = "data", u = "loading", g = "loaded", b = "applied", h = "error", m = "native", p = "data-", f = "ll-status", v = (e, t)=>e.getAttribute(p + t), E = (e)=>v(e, f), I = (e, t)=>((e, t, a)=>{
            const n = p + t;
            null !== a ? e.setAttribute(n, a) : e.removeAttribute(n);
        })(e, f, t), y = (e)=>I(e, null), k = (e)=>null === E(e), A = (e)=>E(e) === m, L = [
        u,
        g,
        b,
        h
    ], w = (e, t, a, n)=>{
        e && "function" == typeof e && (void 0 === n ? void 0 === a ? e(t) : e(t, a) : e(t, a, n));
    }, x = (t, a)=>{
        e && "" !== a && t.classList.add(a);
    }, C = (t, a)=>{
        e && "" !== a && t.classList.remove(a);
    }, O = (e)=>e.llTempImage, M = (e, t)=>{
        if (!t) return;
        const a = t._observer;
        a && a.unobserve(e);
    }, z = (e, t)=>{
        e && (e.loadingCount += t);
    }, N = (e, t)=>{
        e && (e.toLoadCount = t);
    }, T = (e)=>{
        let t = [];
        for(let a, n = 0; a = e.children[n]; n += 1)"SOURCE" === a.tagName && t.push(a);
        return t;
    }, R = (e, t)=>{
        const a = e.parentNode;
        a && "PICTURE" === a.tagName && T(a).forEach(t);
    }, G = (e, t)=>{
        T(e).forEach(t);
    }, D = [
        o
    ], H = [
        o,
        d
    ], V = [
        o,
        r,
        i
    ], F = [
        _
    ], j = (e)=>!!e[c], B = (e)=>e[c], J = (e)=>delete e[c], S = (e, t)=>{
        if (j(e)) return;
        const a = {};
        t.forEach((t)=>{
            a[t] = e.getAttribute(t);
        }), e[c] = a;
    }, P = (e, t)=>{
        if (!j(e)) return;
        const a = B(e);
        t.forEach((t)=>{
            ((e, t, a)=>{
                a ? e.setAttribute(t, a) : e.removeAttribute(t);
            })(e, t, a[t]);
        });
    }, U = (e, t, a)=>{
        x(e, t.class_applied), I(e, b), a && (t.unobserve_completed && M(e, t), w(t.callback_applied, e, a));
    }, $ = (e, t, a)=>{
        x(e, t.class_loading), I(e, u), a && (z(a, 1), w(t.callback_loading, e, a));
    }, q = (e, t, a)=>{
        a && e.setAttribute(t, a);
    }, K = (e, t)=>{
        q(e, i, v(e, t.data_sizes)), q(e, r, v(e, t.data_srcset)), q(e, o, v(e, t.data_src));
    }, Q = {
        IMG: (e, t)=>{
            R(e, (e)=>{
                S(e, V), K(e, t);
            }), S(e, V), K(e, t);
        },
        IFRAME: (e, t)=>{
            S(e, D), q(e, o, v(e, t.data_src));
        },
        VIDEO: (e, t)=>{
            G(e, (e)=>{
                S(e, D), q(e, o, v(e, t.data_src));
            }), S(e, H), q(e, d, v(e, t.data_poster)), q(e, o, v(e, t.data_src)), e.load();
        },
        OBJECT: (e, t)=>{
            S(e, F), q(e, _, v(e, t.data_src));
        }
    }, W = [
        "IMG",
        "IFRAME",
        "VIDEO",
        "OBJECT"
    ], X = (e, t)=>{
        !t || ((e)=>e.loadingCount > 0)(t) || ((e)=>e.toLoadCount > 0)(t) || w(e.callback_finish, t);
    }, Y = (e, t, a)=>{
        e.addEventListener(t, a), e.llEvLisnrs[t] = a;
    }, Z = (e, t, a)=>{
        e.removeEventListener(t, a);
    }, ee = (e)=>!!e.llEvLisnrs, te = (e)=>{
        if (!ee(e)) return;
        const t = e.llEvLisnrs;
        for(let a in t){
            const n = t[a];
            Z(e, a, n);
        }
        delete e.llEvLisnrs;
    }, ae = (e, t, a)=>{
        ((e)=>{
            delete e.llTempImage;
        })(e), z(a, -1), ((e)=>{
            e && (e.toLoadCount -= 1);
        })(a), C(e, t.class_loading), t.unobserve_completed && M(e, a);
    }, ne = (e, t, a)=>{
        const n = O(e) || e;
        ee(n) || ((e, t, a)=>{
            ee(e) || (e.llEvLisnrs = {});
            const n = "VIDEO" === e.tagName ? "loadeddata" : "load";
            Y(e, n, t), Y(e, "error", a);
        })(n, (s)=>{
            ((e, t, a, n)=>{
                const s = A(t);
                ae(t, a, n), x(t, a.class_loaded), I(t, g), w(a.callback_loaded, t, n), s || X(a, n);
            })(0, e, t, a), te(n);
        }, (s)=>{
            ((e, t, a, n)=>{
                const s = A(t);
                ae(t, a, n), x(t, a.class_error), I(t, h), w(a.callback_error, t, n), a.restore_on_error && P(t, V), s || X(a, n);
            })(0, e, t, a), te(n);
        });
    }, se = (e, t, n)=>{
        ((e)=>W.indexOf(e.tagName) > -1)(e) ? ((e, t, a)=>{
            ne(e, t, a), ((e, t, a)=>{
                const n = Q[e.tagName];
                n && (n(e, t), $(e, t, a));
            })(e, t, a);
        })(e, t, n) : ((e, t, n)=>{
            ((e)=>{
                e.llTempImage = document.createElement("IMG");
            })(e), ne(e, t, n), ((e)=>{
                j(e) || (e[c] = {
                    backgroundImage: e.style.backgroundImage
                });
            })(e), ((e, t, n)=>{
                const s = v(e, t.data_bg), l = v(e, t.data_bg_hidpi), r = a && l ? l : s;
                r && (e.style.backgroundImage = `url("${r}")`, O(e).setAttribute(o, r), $(e, t, n));
            })(e, t, n), ((e, t, n)=>{
                const s = v(e, t.data_bg_multi), l = v(e, t.data_bg_multi_hidpi), o = a && l ? l : s;
                o && (e.style.backgroundImage = o, U(e, t, n));
            })(e, t, n), ((e, t, a)=>{
                const n = v(e, t.data_bg_set);
                if (!n) return;
                let s = n.split("|").map((e)=>`image-set(${e})`);
                e.style.backgroundImage = s.join(), U(e, t, a);
            })(e, t, n);
        })(e, t, n);
    }, le = (e)=>{
        e.removeAttribute(o), e.removeAttribute(r), e.removeAttribute(i);
    }, oe = (e)=>{
        R(e, (e)=>{
            P(e, V);
        }), P(e, V);
    }, re = {
        IMG: oe,
        IFRAME: (e)=>{
            P(e, D);
        },
        VIDEO: (e)=>{
            G(e, (e)=>{
                P(e, D);
            }), P(e, H), e.load();
        },
        OBJECT: (e)=>{
            P(e, F);
        }
    }, ie = (e, t)=>{
        ((e)=>{
            const t = re[e.tagName];
            t ? t(e) : ((e)=>{
                if (!j(e)) return;
                const t = B(e);
                e.style.backgroundImage = t.backgroundImage;
            })(e);
        })(e), ((e, t)=>{
            k(e) || A(e) || (C(e, t.class_entered), C(e, t.class_exited), C(e, t.class_applied), C(e, t.class_loading), C(e, t.class_loaded), C(e, t.class_error));
        })(e, t), y(e), J(e);
    }, de = [
        "IMG",
        "IFRAME",
        "VIDEO"
    ], ce = (e)=>e.use_native && "loading" in HTMLImageElement.prototype, _e = (e, t, a)=>{
        e.forEach((e)=>((e)=>e.isIntersecting || e.intersectionRatio > 0)(e) ? ((e, t, a, n)=>{
                const s = ((e)=>L.indexOf(E(e)) >= 0)(e);
                I(e, "entered"), x(e, a.class_entered), C(e, a.class_exited), ((e, t, a)=>{
                    t.unobserve_entered && M(e, a);
                })(e, a, n), w(a.callback_enter, e, t, n), s || se(e, a, n);
            })(e.target, e, t, a) : ((e, t, a, n)=>{
                k(e) || (x(e, a.class_exited), ((e, t, a, n)=>{
                    a.cancel_on_exit && ((e)=>E(e) === u)(e) && "IMG" === e.tagName && (te(e), ((e)=>{
                        R(e, (e)=>{
                            le(e);
                        }), le(e);
                    })(e), oe(e), C(e, a.class_loading), z(n, -1), y(e), w(a.callback_cancel, e, t, n));
                })(e, t, a, n), w(a.callback_exit, e, t, n));
            })(e.target, e, t, a));
    }, ue = (e)=>Array.prototype.slice.call(e), ge = (e)=>e.container.querySelectorAll(e.elements_selector), be = (e)=>((e)=>E(e) === h)(e), he = (e, t)=>((e)=>ue(e).filter(k))(e || ge(t)), me = function(t, a) {
        const n = s(t);
        this._settings = n, this.loadingCount = 0, ((e, t)=>{
            ce(e) || (t._observer = new IntersectionObserver((a)=>{
                _e(a, e, t);
            }, ((e)=>({
                    root: e.container === document ? null : e.container,
                    rootMargin: e.thresholds || e.threshold + "px"
                }))(e)));
        })(n, this), ((t, a)=>{
            e && (a._onlineHandler = ()=>{
                ((e, t)=>{
                    var a;
                    (a = ge(e), ue(a).filter(be)).forEach((t)=>{
                        C(t, e.class_error), y(t);
                    }), t.update();
                })(t, a);
            }, window.addEventListener("online", a._onlineHandler));
        })(n, this), this.update(a);
    };
    return me.prototype = {
        update: function(e) {
            const a = this._settings, n = he(e, a);
            var s, l;
            N(this, n.length), t ? this.loadAll(n) : ce(a) ? ((e, t, a)=>{
                e.forEach((e)=>{
                    -1 !== de.indexOf(e.tagName) && ((e, t, a)=>{
                        e.setAttribute("loading", "lazy"), ne(e, t, a), ((e, t)=>{
                            const a = Q[e.tagName];
                            a && a(e, t);
                        })(e, t), I(e, m);
                    })(e, t, a);
                }), N(a, 0);
            })(n, a, this) : (l = n, ((e)=>{
                e.disconnect();
            })(s = this._observer), ((e, t)=>{
                t.forEach((t)=>{
                    e.observe(t);
                });
            })(s, l));
        },
        destroy: function() {
            this._observer && this._observer.disconnect(), e && window.removeEventListener("online", this._onlineHandler), ge(this._settings).forEach((e)=>{
                J(e);
            }), delete this._observer, delete this._settings, delete this._onlineHandler, delete this.loadingCount, delete this.toLoadCount;
        },
        loadAll: function(e) {
            const t = this._settings;
            he(e, t).forEach((e)=>{
                M(e, this), se(e, t, this);
            });
        },
        restoreAll: function() {
            const e = this._settings;
            ge(e).forEach((t)=>{
                ie(t, e);
            });
        }
    }, me.load = (e, t)=>{
        const a = s(t);
        se(e, a);
    }, me.resetStatus = (e)=>{
        y(e);
    }, e && ((e, t)=>{
        if (t) {
            if (t.length) for(let a, n = 0; a = t[n]; n += 1)l(e, a);
            else l(e, t);
        }
    })(me, window.lazyLoadOptions), me;
});


const $1da0326b5a3443a3$export$a34cd87b205083 = new (0, (/*@__PURE__*/$parcel$interopDefault($fdddc8610c676f7c$exports)))({
    elements_selector: "[data-src], [data-bg]"
});


const $59251f0f109f763e$var$mainNav = document.querySelector(".m-nav");
const $59251f0f109f763e$var$overlayHeader = document.querySelector(".c-overlay-header");
const $59251f0f109f763e$export$c6453edf75ff27d = window.matchMedia("(max-width: 61.999em)"); // Change to your needs
const $59251f0f109f763e$var$closers = document.querySelectorAll(".--js-main-nav-closer");
const $59251f0f109f763e$var$openers = document.querySelectorAll(".--js-main-nav-opener");
const $59251f0f109f763e$var$togglers = document.querySelectorAll(".--js-main-nav-toggler");
const $59251f0f109f763e$export$69ff42680518db68 = (event)=>{
    event?.preventDefault();
    $59251f0f109f763e$var$mainNav?.classList.remove("--open");
    $59251f0f109f763e$var$overlayHeader?.classList.remove("--show");
    document.body.style.setProperty("overflow", null);
};
const $59251f0f109f763e$var$openMenu = (event)=>{
    event.preventDefault();
    $59251f0f109f763e$var$mainNav?.classList.add("--open");
    $59251f0f109f763e$var$mainNav?.classList.add("--transition");
    $59251f0f109f763e$var$overlayHeader?.classList.add("--show");
    document.body.style.setProperty("overflow", "hidden");
};
const $59251f0f109f763e$var$toggleMenu = (event)=>{
    $59251f0f109f763e$var$mainNav?.classList.contains("--open") ? $59251f0f109f763e$export$69ff42680518db68(event) : $59251f0f109f763e$var$openMenu(event);
};
const $59251f0f109f763e$export$c7275940d9d47712 = ()=>$59251f0f109f763e$var$mainNav?.classList.remove("--transition");
$59251f0f109f763e$var$closers.forEach((closer)=>{
    closer.addEventListener("click", $59251f0f109f763e$export$69ff42680518db68);
});
$59251f0f109f763e$var$openers.forEach((opener)=>{
    opener.addEventListener("click", $59251f0f109f763e$var$openMenu);
});
$59251f0f109f763e$var$togglers.forEach((toggler)=>{
    toggler.addEventListener("click", $59251f0f109f763e$var$toggleMenu);
});



const $4d879892f94e3a11$var$submenuSecondLevels = document.querySelectorAll(".i-menu.--level-2 .i-menu__submenu");
const $4d879892f94e3a11$var$documentWidth = document.documentElement.offsetWidth;
const $4d879892f94e3a11$var$isOverflowing = (box)=>box.left < 0 || box.right > $4d879892f94e3a11$var$documentWidth;
const $4d879892f94e3a11$var$handleOverflows = ()=>{
    if ((0, $59251f0f109f763e$export$c6453edf75ff27d).matches) return; // its mobile, so we dont care
    $4d879892f94e3a11$var$submenuSecondLevels.forEach((element)=>{
        element.classList.toggle("--mirror", $4d879892f94e3a11$var$isOverflowing(element.getBoundingClientRect()));
    });
};
const $4d879892f94e3a11$var$resizeObserver = new ResizeObserver($4d879892f94e3a11$var$handleOverflows);
$4d879892f94e3a11$var$resizeObserver.observe(document.documentElement);



const $4ecb853dc3b6f9f6$var$handleMobileChange = (mediaQueryList)=>{
    if (mediaQueryList.matches) return; // its mobile
    (0, $59251f0f109f763e$export$c7275940d9d47712)();
    (0, $59251f0f109f763e$export$69ff42680518db68)();
};
(0, $59251f0f109f763e$export$c6453edf75ff27d).addEventListener("change", $4ecb853dc3b6f9f6$var$handleMobileChange);




var $0212d1407ea555e8$exports = {};
/*!
 * headroom.js v0.12.0 - Give your page some headroom. Hide your header until you need it
 * Copyright (c) 2020 Nick Williams - http://wicky.nillia.ms/headroom.js
 * License: MIT
 */ (function(global, factory) {
    $0212d1407ea555e8$exports = factory();
})($0212d1407ea555e8$exports, function() {
    'use strict';
    function isBrowser() {
        return typeof window !== "undefined";
    }
    /**
   * Used to detect browser support for adding an event listener with options
   * Credit: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
   */ function passiveEventsSupported() {
        var supported = false;
        try {
            var options = {
                // eslint-disable-next-line getter-return
                get passive () {
                    supported = true;
                }
            };
            window.addEventListener("test", options, options);
            window.removeEventListener("test", options, options);
        } catch (err) {
            supported = false;
        }
        return supported;
    }
    function isSupported() {
        return !!(isBrowser() && (function() {}).bind && "classList" in document.documentElement && Object.assign && Object.keys && requestAnimationFrame);
    }
    function isDocument(obj) {
        return obj.nodeType === 9; // Node.DOCUMENT_NODE === 9
    }
    function isWindow(obj) {
        // `obj === window` or `obj instanceof Window` is not sufficient,
        // as the obj may be the window of an iframe.
        return obj && obj.document && isDocument(obj.document);
    }
    function windowScroller(win) {
        var doc = win.document;
        var body = doc.body;
        var html = doc.documentElement;
        return {
            /**
       * @see http://james.padolsey.com/javascript/get-document-height-cross-browser/
       * @return {Number} the scroll height of the document in pixels
       */ scrollHeight: function() {
                return Math.max(body.scrollHeight, html.scrollHeight, body.offsetHeight, html.offsetHeight, body.clientHeight, html.clientHeight);
            },
            /**
       * @see http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript
       * @return {Number} the height of the viewport in pixels
       */ height: function() {
                return win.innerHeight || html.clientHeight || body.clientHeight;
            },
            /**
       * Gets the Y scroll position
       * @return {Number} pixels the page has scrolled along the Y-axis
       */ scrollY: function() {
                if (win.pageYOffset !== undefined) return win.pageYOffset;
                return (html || body.parentNode || body).scrollTop;
            }
        };
    }
    function elementScroller(element) {
        return {
            /**
       * @return {Number} the scroll height of the element in pixels
       */ scrollHeight: function() {
                return Math.max(element.scrollHeight, element.offsetHeight, element.clientHeight);
            },
            /**
       * @return {Number} the height of the element in pixels
       */ height: function() {
                return Math.max(element.offsetHeight, element.clientHeight);
            },
            /**
       * Gets the Y scroll position
       * @return {Number} pixels the element has scrolled along the Y-axis
       */ scrollY: function() {
                return element.scrollTop;
            }
        };
    }
    function createScroller(element) {
        return isWindow(element) ? windowScroller(element) : elementScroller(element);
    }
    /**
   * @param element EventTarget
   */ function trackScroll(element, options, callback) {
        var isPassiveSupported = passiveEventsSupported();
        var rafId;
        var scrolled = false;
        var scroller = createScroller(element);
        var lastScrollY = scroller.scrollY();
        var details = {};
        function update() {
            var scrollY = Math.round(scroller.scrollY());
            var height = scroller.height();
            var scrollHeight = scroller.scrollHeight();
            // reuse object for less memory churn
            details.scrollY = scrollY;
            details.lastScrollY = lastScrollY;
            details.direction = scrollY > lastScrollY ? "down" : "up";
            details.distance = Math.abs(scrollY - lastScrollY);
            details.isOutOfBounds = scrollY < 0 || scrollY + height > scrollHeight;
            details.top = scrollY <= options.offset[details.direction];
            details.bottom = scrollY + height >= scrollHeight;
            details.toleranceExceeded = details.distance > options.tolerance[details.direction];
            callback(details);
            lastScrollY = scrollY;
            scrolled = false;
        }
        function handleScroll() {
            if (!scrolled) {
                scrolled = true;
                rafId = requestAnimationFrame(update);
            }
        }
        var eventOptions = isPassiveSupported ? {
            passive: true,
            capture: false
        } : false;
        element.addEventListener("scroll", handleScroll, eventOptions);
        update();
        return {
            destroy: function() {
                cancelAnimationFrame(rafId);
                element.removeEventListener("scroll", handleScroll, eventOptions);
            }
        };
    }
    function normalizeUpDown(t) {
        return t === Object(t) ? t : {
            down: t,
            up: t
        };
    }
    /**
   * UI enhancement for fixed headers.
   * Hides header when scrolling down
   * Shows header when scrolling up
   * @constructor
   * @param {DOMElement} elem the header element
   * @param {Object} options options for the widget
   */ function Headroom(elem, options) {
        options = options || {};
        Object.assign(this, Headroom.options, options);
        this.classes = Object.assign({}, Headroom.options.classes, options.classes);
        this.elem = elem;
        this.tolerance = normalizeUpDown(this.tolerance);
        this.offset = normalizeUpDown(this.offset);
        this.initialised = false;
        this.frozen = false;
    }
    Headroom.prototype = {
        constructor: Headroom,
        /**
     * Start listening to scrolling
     * @public
     */ init: function() {
            if (Headroom.cutsTheMustard && !this.initialised) {
                this.addClass("initial");
                this.initialised = true;
                // defer event registration to handle browser
                // potentially restoring previous scroll position
                setTimeout(function(self) {
                    self.scrollTracker = trackScroll(self.scroller, {
                        offset: self.offset,
                        tolerance: self.tolerance
                    }, self.update.bind(self));
                }, 100, this);
            }
            return this;
        },
        /**
     * Destroy the widget, clearing up after itself
     * @public
     */ destroy: function() {
            this.initialised = false;
            Object.keys(this.classes).forEach(this.removeClass, this);
            this.scrollTracker.destroy();
        },
        /**
     * Unpin the element
     * @public
     */ unpin: function() {
            if (this.hasClass("pinned") || !this.hasClass("unpinned")) {
                this.addClass("unpinned");
                this.removeClass("pinned");
                if (this.onUnpin) this.onUnpin.call(this);
            }
        },
        /**
     * Pin the element
     * @public
     */ pin: function() {
            if (this.hasClass("unpinned")) {
                this.addClass("pinned");
                this.removeClass("unpinned");
                if (this.onPin) this.onPin.call(this);
            }
        },
        /**
     * Freezes the current state of the widget
     * @public
     */ freeze: function() {
            this.frozen = true;
            this.addClass("frozen");
        },
        /**
     * Re-enables the default behaviour of the widget
     * @public
     */ unfreeze: function() {
            this.frozen = false;
            this.removeClass("frozen");
        },
        top: function() {
            if (!this.hasClass("top")) {
                this.addClass("top");
                this.removeClass("notTop");
                if (this.onTop) this.onTop.call(this);
            }
        },
        notTop: function() {
            if (!this.hasClass("notTop")) {
                this.addClass("notTop");
                this.removeClass("top");
                if (this.onNotTop) this.onNotTop.call(this);
            }
        },
        bottom: function() {
            if (!this.hasClass("bottom")) {
                this.addClass("bottom");
                this.removeClass("notBottom");
                if (this.onBottom) this.onBottom.call(this);
            }
        },
        notBottom: function() {
            if (!this.hasClass("notBottom")) {
                this.addClass("notBottom");
                this.removeClass("bottom");
                if (this.onNotBottom) this.onNotBottom.call(this);
            }
        },
        shouldUnpin: function(details) {
            var scrollingDown = details.direction === "down";
            return scrollingDown && !details.top && details.toleranceExceeded;
        },
        shouldPin: function(details) {
            var scrollingUp = details.direction === "up";
            return scrollingUp && details.toleranceExceeded || details.top;
        },
        addClass: function(className) {
            this.elem.classList.add.apply(this.elem.classList, this.classes[className].split(" "));
        },
        removeClass: function(className) {
            this.elem.classList.remove.apply(this.elem.classList, this.classes[className].split(" "));
        },
        hasClass: function(className) {
            return this.classes[className].split(" ").every(function(cls) {
                return this.classList.contains(cls);
            }, this.elem);
        },
        update: function(details) {
            if (details.isOutOfBounds) // Ignore bouncy scrolling in OSX
            return;
            if (this.frozen === true) return;
            if (details.top) this.top();
            else this.notTop();
            if (details.bottom) this.bottom();
            else this.notBottom();
            if (this.shouldUnpin(details)) this.unpin();
            else if (this.shouldPin(details)) this.pin();
        }
    };
    /**
   * Default options
   * @type {Object}
   */ Headroom.options = {
        tolerance: {
            up: 0,
            down: 0
        },
        offset: 0,
        scroller: isBrowser() ? window : null,
        classes: {
            frozen: "headroom--frozen",
            pinned: "headroom--pinned",
            unpinned: "headroom--unpinned",
            top: "headroom--top",
            notTop: "headroom--not-top",
            bottom: "headroom--bottom",
            notBottom: "headroom--not-bottom",
            initial: "headroom"
        }
    };
    Headroom.cutsTheMustard = isSupported();
    return Headroom;
});


const $615896e864cf8376$var$mainHeader = document.querySelector(".m-header");
const $615896e864cf8376$var$headRoomHeaderOptions = {
    offset: $615896e864cf8376$var$mainHeader?.clientHeight ?? 0
};
const $615896e864cf8376$export$53c9451103e8e84e = $615896e864cf8376$var$mainHeader ? new (0, (/*@__PURE__*/$parcel$interopDefault($0212d1407ea555e8$exports)))($615896e864cf8376$var$mainHeader, $615896e864cf8376$var$headRoomHeaderOptions) : null;
if ($615896e864cf8376$export$53c9451103e8e84e) $615896e864cf8376$export$53c9451103e8e84e.init();


window.lazyloading = (0, $1da0326b5a3443a3$export$a34cd87b205083); // add lazyloading to global window object



async function $57bab93eb66b26b1$var$loadFancybox() {
    await (parcelRequire("kUkf0"));
    if (document.querySelectorAll(".entry-content .kt-img-link, .entry-content a").length) await (parcelRequire("kRT5c"));
    if (document.querySelectorAll("[data-fancybox]").length) await (parcelRequire("1C2eD"));
}
$57bab93eb66b26b1$var$loadFancybox();

async function $57bab93eb66b26b1$var$loadModals() {
    if (document.querySelectorAll(".c-modal").length) await (parcelRequire("jho76"));
}
$57bab93eb66b26b1$var$loadModals();

async function $57bab93eb66b26b1$var$loadFileInput() {
    if (document.querySelectorAll(".f-file").length) await (parcelRequire("6h2ZC"));
}
$57bab93eb66b26b1$var$loadFileInput();

async function $57bab93eb66b26b1$var$loadDateInput() {
    if (document.querySelectorAll(".f-date").length) await (parcelRequire("e9lkY"));
}
$57bab93eb66b26b1$var$loadDateInput();

async function $57bab93eb66b26b1$var$loadPasswordField() {
    if (document.querySelectorAll(".f-text.--password").length) await (parcelRequire("4aMyn"));
}
$57bab93eb66b26b1$var$loadPasswordField();

async function $57bab93eb66b26b1$var$loadCalendar() {
    if (document.querySelectorAll(".s-calendar").length) await (parcelRequire("wmyCC"));
}
$57bab93eb66b26b1$var$loadCalendar();

async function $57bab93eb66b26b1$var$loadSlimSelect() {
    if (document.querySelectorAll(".slim-select").length) await (parcelRequire("aY5zW"));
}
$57bab93eb66b26b1$var$loadSlimSelect();

async function $57bab93eb66b26b1$var$loadAlerts() {
    if (document.querySelectorAll(".i-alert").length) await (parcelRequire("cZVn5"));
}
$57bab93eb66b26b1$var$loadAlerts();

async function $57bab93eb66b26b1$var$loadNotification() {
    if (document.querySelectorAll(".i-notification").length) await (parcelRequire("cTvfh"));
}
$57bab93eb66b26b1$var$loadNotification();

async function $57bab93eb66b26b1$var$loadFaqItem() {
    if (document.querySelectorAll(".i-faq").length) await (parcelRequire("9a4rI"));
}
$57bab93eb66b26b1$var$loadFaqItem();

async function $57bab93eb66b26b1$var$loadSwiper() {
    if (document.querySelectorAll(".swiper").length) await (parcelRequire("3DiM9"));
}
$57bab93eb66b26b1$var$loadSwiper();

async function $57bab93eb66b26b1$var$loadCheckboxSelectField() {
    if (document.querySelectorAll(".f-checkbox-select").length) await (parcelRequire("gWmnw"));
}
$57bab93eb66b26b1$var$loadCheckboxSelectField();

async function $57bab93eb66b26b1$var$loadOverlayScrollbars() {
    if (document.querySelectorAll(".u-scrollbar").length) await (parcelRequire("aAMLD"));
}
$57bab93eb66b26b1$var$loadOverlayScrollbars();

async function $57bab93eb66b26b1$var$loadBaseForm() {
    if (document.querySelectorAll("form.--validate").length) await (parcelRequire("fqTok"));
}
$57bab93eb66b26b1$var$loadBaseForm();

async function $57bab93eb66b26b1$var$loadScrollUp() {
    if (document.querySelectorAll(".c-scroll-up").length) await (parcelRequire("2whGw"));
}
$57bab93eb66b26b1$var$loadScrollUp();

async function $57bab93eb66b26b1$var$loadThemeConfig() {
    if (document.querySelectorAll(".c-theme-config").length) await (parcelRequire("ib06j"));
}
$57bab93eb66b26b1$var$loadThemeConfig();

async function $57bab93eb66b26b1$var$loadTabs() {
    if (document.querySelectorAll(".js-tabs").length) await (parcelRequire("byeGr"));
}
$57bab93eb66b26b1$var$loadTabs();

async function $57bab93eb66b26b1$var$loadExternalSvgLoader() {
    if (document.querySelectorAll(".c-svg").length) await (parcelRequire("gQuGa"));
}
$57bab93eb66b26b1$var$loadExternalSvgLoader();

async function $57bab93eb66b26b1$var$loadMenuItem() {
    if (document.querySelectorAll(".i-menu.--has-submenu").length) await (parcelRequire("agtdj"));
}
$57bab93eb66b26b1$var$loadMenuItem();

async function $57bab93eb66b26b1$var$loadMainHeaderSearch() {
    if (document.querySelectorAll(".m-header-search").length) await (parcelRequire("3jY46"));
}
$57bab93eb66b26b1$var$loadMainHeaderSearch();


async function $57bab93eb66b26b1$var$loadWordpressEntryContent() {
    if (document.querySelectorAll(".entry-content iframe").length) await (parcelRequire("ggz7T"));
    if (document.querySelectorAll(".entry-content table").length) await (parcelRequire("lsfvb"));
}
$57bab93eb66b26b1$var$loadWordpressEntryContent();

async function $57bab93eb66b26b1$var$loadWordpressMenuItem() {
    if (document.querySelectorAll(".menu-item-has-children, .page_item_has_children").length) await (parcelRequire("VWzl8"));
}
$57bab93eb66b26b1$var$loadWordpressMenuItem();

async function $57bab93eb66b26b1$var$loadWordpressAside() {
    if (document.querySelectorAll(".widget_categories, .widget_nav_menu, .widget_pages").length) await (parcelRequire("iAQmS"));
}
$57bab93eb66b26b1$var$loadWordpressAside();

async function $57bab93eb66b26b1$var$loadHoney() {
    if (document.querySelectorAll("input.js-honey").length) await (parcelRequire("73LSn"));
}
$57bab93eb66b26b1$var$loadHoney();

async function $57bab93eb66b26b1$var$loadTextAndMediaSlider() {
    if (document.querySelectorAll(".g-text-and-media-slider").length) await (parcelRequire("8pwOZ"));
}
$57bab93eb66b26b1$var$loadTextAndMediaSlider();

async function $57bab93eb66b26b1$var$loadReviewSlider() {
    if (document.querySelectorAll(".g-review.--slider").length) await (parcelRequire("k9xZt"));
}
$57bab93eb66b26b1$var$loadReviewSlider();

async function $57bab93eb66b26b1$var$loadVideoSection() {
    if (document.querySelectorAll(".s-video__content").length) await (parcelRequire("hPGrL"));
}
$57bab93eb66b26b1$var$loadVideoSection();


//# sourceMappingURL=index.js.map
